import React from "react";
import { JobDescriptionProps } from "../components/MyJobs";

export interface DeleteTeamJobDescriptionSummary {
  teamName: string;
  teamId: string;
  numberOfTeamChildren: string;
  parentTeamName: string;
}

function getDescriptionFromSummary(
  summary: DeleteTeamJobDescriptionSummary
): string {
  const teamName = summary.teamName;
  const numberOfChildren = summary.numberOfTeamChildren;
  const parentTeamName = summary.parentTeamName;
  const subTeamsText =
    parseInt(numberOfChildren) > 1
      ? `${numberOfChildren} sub teams`
      : `${numberOfChildren} sub team`;
  return `Delete "${teamName}" and move ${subTeamsText} under "${parentTeamName}"`;
}

function isValidSummary(summary: DeleteTeamJobDescriptionSummary): boolean {
  return (
    !!summary &&
    !!summary.teamName &&
    !!summary.numberOfTeamChildren &&
    !!summary.parentTeamName
  );
}

const DeleteTeamsJobDescription: React.FC<JobDescriptionProps> = ({
  job,
}): JSX.Element => {
  const summary = job.summary as DeleteTeamJobDescriptionSummary;
  let description = "-";

  if (isValidSummary(summary)) {
    description = getDescriptionFromSummary(summary);
  }

  return <div>{description}</div>;
};

export default DeleteTeamsJobDescription;
